export const sources={};export const img={src:"__VITE_ASSET__TX5a1iViCylaCWPFSCQG2w__",w:640,h:640};export default{sources:sources,img:img};